class MainBlog extends HTMLElement {
  constructor() {
    super();
    this.loadMoreWrapper = this.querySelector("[data-load-more-wrapper]");
  }

  connectedCallback() {
    this.addEventListener("click", (e) => {
      const loadMore = e.target.closest("[data-load-more]");

      if (!loadMore) return;

      e.preventDefault();

      this._loadMore();
    });
  }

  _loadMore() {
    const loadMore = this.querySelector("[data-load-more]");
    const grid = this.querySelector("[data-grid]");

    fetch(loadMore.href)
      .then((response) => response.text())
      .then((response) => {
        const doc = new DOMParser().parseFromString(response, "text/html");

        const newLoadMore = doc.querySelector("[data-load-more]");
        if (!newLoadMore) {
          loadMore.style.display = "none";
          this.observer?.disconnect();
        } else {
          loadMore.href = newLoadMore.href;
          loadMore.setAttribute(
            "data-current-page",
            newLoadMore.getAttribute("data-current-page"),
          );
          loadMore.innerHTML = newLoadMore.innerHTML;
        }

        grid.append(...doc.querySelectorAll("[data-card]"));
      });
  }
}

if (!customElements.get("main-blog")) {
  customElements.define("main-blog", MainBlog);
}
